import {HttpClient} from "../../service/httpClient/HttpClient";

export class OtherPaymentService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getTransactions(fundID, accountId, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/deposit-accounts/${accountId}/movements`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }
}